/* eslint-disable prefer-const -- original legacy script */

const ONE_TRUST_STUB_URL = 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js';

function installOneTrust() {
  window.dla = window.dla || {};
  window.dla.oneTrust = (function () {
    function getCookieValueByName(name: string) {
      let match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
      if (match) {
        return match[2];
      }
    }

    function parseQuery(queryString: string | undefined) {
      if (!queryString) {
        return;
      }
      let query: Record<string, string> = {};
      let pairs = (queryString[0] === '?' ? queryString.substr(1) : queryString).split('&');
      for (let i = 0; i < pairs.length; i++) {
        let pair = pairs[i]!.split('=');
        query[decodeURIComponent(pair[0]!)] = decodeURIComponent(pair[1] || '');
      }
      return query;
    }

    function setOneTrustCookieAlertBoxClosed(currentDate: Date, expirationDate: Date) {
      document.cookie = 'OptanonAlertBoxClosed=' + currentDate.toISOString() + '; Path=/; Expires=' + expirationDate.toUTCString() + '; SameSite=Lax;';
    }

    function setOneTrustCookie(value: string, expirationDate: Date) {
      document.cookie = 'OptanonConsent=' + value + '; Path=/; Expires=' + expirationDate.toUTCString() + '; SameSite=Lax;';
    }

    function setGroups(statisticCookies: boolean, functionalCookies: boolean, targetingCookies: boolean) {
      return 'C0001:1' + ',C0002:' + (statisticCookies ? '1' : '0') + ',C0003:' + (functionalCookies ? '1' : '0') + ',C0004:' + (targetingCookies ? '1' : '0');
    }

    function encodeTrustCookie(oneTrustCookie: Record<string, string | Date>) {
      let result = '';
      for (const [key, value] of Object.entries(oneTrustCookie)) {
        result = result + encodeURIComponent(key) + '=' + (encodeURIComponent(value as string) || '') + '&';
      }
      return result.substr(0, result.length - 1);
    }

    function setOneTrustCookieGroups(statisticCookies: boolean, functionalCookies: boolean, targetingCookies: boolean) {
      let oneTrustCookie: Record<string, string | Date> | undefined = parseQuery(getCookieValueByName('OptanonConsent'));

      if (!oneTrustCookie) {
        oneTrustCookie = {
          groups: setGroups(statisticCookies, functionalCookies, targetingCookies),
          datestamp: new Date(),
        };
      } else {
        oneTrustCookie.groups = setGroups(statisticCookies, functionalCookies, targetingCookies);
        oneTrustCookie.datestamp = new Date();
      }

      let newTrustCookieValue = encodeTrustCookie(oneTrustCookie);
      let expirationDate = new Date(new Date().setFullYear(new Date().getFullYear() + 1));
      setOneTrustCookie(newTrustCookieValue, expirationDate);
      setOneTrustCookieAlertBoxClosed(oneTrustCookie.datestamp as Date, expirationDate);
    }

    return {
      setOneTrustCookieGroups: setOneTrustCookieGroups,
    };
  })();
}

function appendOneTrustScriptTag(domainScript: string): void {
  const script = document.createElement('script');
  script.src = ONE_TRUST_STUB_URL;
  script.type = 'text/javascript';
  script.charset = 'UTF-8';
  script.setAttribute('data-domain-script', domainScript);
  document.head.appendChild(script);
}

export { appendOneTrustScriptTag, installOneTrust };
